
import { defineComponent } from 'vue'
import { ACTION_BACKGROUND_JOB } from '@/store/actions'
import { IBackgroundJob } from '@/api/backgroundJob'
import { is } from 'date-fns/locale'

export default defineComponent({
  name: 'ListJob',
  props: {
    appId: {
      type: String,
      required: true,
    },
    isTestMode: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    jobs(): IBackgroundJob[] {
      return this.$store.state.backgroundJob.items ?? []
    },
    hasProcessingJobs(): boolean {
      return this.jobs.some((p) => p?.status === 'PENDING' || p?.status === 'RUNNING')
    },
  },
  watch: {
    hasProcessingJobs(newVal) {
      if (newVal) {
        this.startIntervalChecker()
      } else if (this.intervalChecker) {
        this.clearIntervalChecker()
      }
    },
    isTestMode(newVal) {
      if (this.intervalChecker) {
        this.clearIntervalChecker()
      }
      ;(this.$refs.tableRef as any).requestServerInteraction()
    },
  },
  data() {
    return {
      loading: false,
      pagination: {
        page: 1,
        rowsPerPage: 10,
        rowsNumber: 100,
      },
      intervalChecker: undefined as any,
      columns: [
        { name: 'month', label: this.$t('label.log_report.result.target_month'), align: 'left' },
        { name: 'status', label: this.$t('label.log_report.result.status'), align: 'left' },
        { name: 'logType', label: this.$t('label.log_report.log_type'), align: 'left' },
        {
          name: 'recordCount',
          label: this.$t('label.log_report.result.number_of_records'),
          align: 'right',
        },
        { name: 'createdAt', label: this.$t('label.log_report.result.created_at'), align: 'left' },
        { name: 'creator', label: this.$t('label.log_report.result.author'), align: 'left' },
        { name: 'actions', align: 'right', sortable: false },
      ],
      logTypes: {
        popup_displayclick: this.$t('label.log_report.popup_click_log_type'),
        popup_cv: this.$t('label.log_report.popup_cv_log_type'),
        tracking_id: this.$t('label.log_report.tracking_id_log_type'),
      },
      jobStatusNames: {
        PENDING: this.$t('label.log_report.job_status.pending'),
        RUNNING: this.$t('label.log_report.job_status.running'),
        COMPLETED: this.$t('label.log_report.job_status.completed'),
        FAILED: this.$t('label.log_report.job_status.failed'),
      },
      jobStatusColors: {
        PENDING: 'secondary-2',
        RUNNING: 'primary-2',
        COMPLETED: 'green',
        FAILED: 'negative',
      },
    }
  },
  methods: {
    async onRequestData(props: any) {
      this.loading = true
      const { page, rowsPerPage } = props.pagination
      const resp = await this.getJobs(page, rowsPerPage)
      this.pagination.page = page
      this.pagination.rowsPerPage = rowsPerPage
      this.pagination.rowsNumber = resp.total_items ?? 0
      this.loading = false
    },
    async getJobs(pageInex: number, pageSize: number) {
      return this.$store.dispatch(ACTION_BACKGROUND_JOB.LOAD_ITEMS, {
        app_id: this.appId,
        page: pageInex,
        page_size: pageSize,
        is_test_mode: this.isTestMode,
      })
    },
    onDownloadLog(row: IBackgroundJob) {
      window.open(row.result?.file_path, '_blank')
    },
    /**
     * Start an interval to update the job list if there are processing jobs.
     */
    startIntervalChecker() {
      if (!this.intervalChecker) {
        this.intervalChecker = setInterval(() => {
          this.$refs.tableRef.requestServerInteraction()
        }, 1000)
      }
    },
    clearIntervalChecker() {
      if (this.intervalChecker) {
        clearInterval(this.intervalChecker)
        this.intervalChecker = undefined
      }
    },
  },
  mounted() {
    ;(this.$refs.tableRef as any).requestServerInteraction()
  },
  unmounted() {
    this.clearIntervalChecker()
  },
})
